'use strict';

function FormHandler(reviewId, trigger) {

    var container = $('#report-'+reviewId);

    this.form = container.find('.report-form');
    this.trigger = container.find('.submit-button');
    this.editor = container.find('.report-review-form');
    this.confirmation = container.find('.report-review-confirmation');
    this.reviewId = reviewId;
    this.modal = $(trigger);

    if (this.modal.length === 0) return; // prevent leanModal blowing up when there are no elements to attach to

    this.modal.leanModal({closeButton: ".cancel-button"});

}

FormHandler.prototype = {

    validate: function() {

        var validators = {
            isEmpty: function (field) {
                return (field.val().length === 0);
            },
            isEmail: function (field) {
                var email = field.val();
                return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
            }
        };

        var inputs = this.form.find(':input:not("button")');
        $('.validation-message').hide();

        var formValid = true;
        $.each(inputs, function(idx, field) {
            var $field = $(field);

            if (validators.isEmpty($field)) {
                 $('.validation-'+$field.attr('name')+'-required').show();
                formValid = false;
            }

            if (formValid && field.type === 'email' && !validators.isEmail($field)) {
                $('.validation-'+$field.attr('name')+'-email').show();
                formValid = false;
            }
        });

        if (formValid) {
            this.send();
        }

    },

    send: function() {

        var self = this;

        var complaint = {
            name: self.form.find('*[name=name]').val(),
            email: self.form.find('*[name=email]').val(),
            message: self.form.find('*[name=message]').val(),
            reviewContent: $('#comment-'+self.reviewId).html(),
            title: document.title,
            url: window.location.href
        };

        $.ajax({
            type: 'POST',
            url: '/api/feedback/review/'+this.reviewId+'/report',
            data: JSON.stringify(complaint),
            success: self.showConfirmation.bind(self),
            contentType: "application/json; charset=utf-8",
            dataType: 'json'
        });

    },

    showConfirmation: function() {
        this.confirmation.show();
        this.editor.hide();
    },

    enable: function() {
        this.trigger.on('click', this.validate.bind(this));
        $('.validation-message').hide();
        this.confirmation.hide();
        this.editor.show();
    }

};
